var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagRu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "flagRu_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EEEEEC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#flagRu_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0v8h24V0z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16H0v8h24v-8z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 8H0v8h24V8z",
    fill: "#41479B"
  }))));
}
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgImRhdGE6aW1hZ2Uvc3ZnK3htbDtiYXNlNjQsUEhOMlp5QjNhV1IwYUQwaU1qUWlJR2hsYVdkb2REMGlNalFpSUhacFpYZENiM2c5SWpBZ01DQXlOQ0F5TkNJZ1ptbHNiRDBpYm05dVpTSWdlRzFzYm5NOUltaDBkSEE2THk5M2QzY3Vkek11YjNKbkx6SXdNREF2YzNabklqNEtQR2NnYVdROUlrWnNZV2NpUGdvOGJXRnpheUJwWkQwaWJXRnphekJmTVRBMlh6RXpNakVpSUhOMGVXeGxQU0p0WVhOckxYUjVjR1U2WVd4d2FHRWlJRzFoYzJ0VmJtbDBjejBpZFhObGNsTndZV05sVDI1VmMyVWlJSGc5SWpBaUlIazlJakFpSUhkcFpIUm9QU0l5TkNJZ2FHVnBaMmgwUFNJeU5DSStDanhqYVhKamJHVWdhV1E5SWtWc2JHbHdjMlVnT0NJZ1kzZzlJakV5SWlCamVUMGlNVElpSUhJOUlqRXlJaUJtYVd4c1BTSWpSVVZGUlVWRElpOCtDand2YldGemF6NEtQR2NnYldGemF6MGlkWEpzS0NOdFlYTnJNRjh4TURaZk1UTXlNU2tpUGdvOFp5QnBaRDBpUjNKdmRYQWdNallpUGdvOGNHRjBhQ0JwWkQwaVZtVmpkRzl5SWlCa1BTSk5NalFnTUVnd1ZqY3VPVGs1T1RkSU1qUldNRm9pSUdacGJHdzlJaU5HTlVZMVJqVWlMejRLUEhCaGRHZ2dhV1E5SWxabFkzUnZjbDh5SWlCa1BTSk5NalFnTVRaSU1GWXlORWd5TkZZeE5sb2lJR1pwYkd3OUlpTkdSalJDTlRVaUx6NEtQSEJoZEdnZ2FXUTlJbFpsWTNSdmNsOHpJaUJrUFNKTk1qUWdPQzR3TURBd05rZ3dWakUyU0RJMFZqZ3VNREF3TURaYUlpQm1hV3hzUFNJak5ERTBOemxDSWk4K0Nqd3ZaejRLUEM5blBnbzhMMmMrQ2p3dmMzWm5QZ289Ig==";
export { SvgFlagRu as ReactComponent };